import type { ReactNode } from "react";

import { usePermission } from "@/hooks/usePermission";

interface AuthButtonProps {
  /** 权限码，不传则始终展示子节点 */
  code?: string;
  /** 无权限时的占位，默认不渲染 */
  fallback?: ReactNode;
  children: ReactNode;
}

/**
 * 按钮级权限包装：无权限时不渲染子节点（或展示 fallback）
 */
export const AuthButton = ({ code, children, fallback = null }: AuthButtonProps) => {
  const allowed = usePermission(code);
  if (!allowed) return fallback;
  return children;
};
